import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import ApiService from './api.service.abstract';
import { APP_CONFIG } from '@pulpo/app-config';
import {
  Formality,
  PrestationLock,
  UNVERIFIED_LOCK,
} from '@pulpo/pulpo-models';
import { Observable, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FormalityService extends ApiService<Formality> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'api/formalities');
  }

  /** The product locking the formality once imported into a trip, null when it is editable. */
  findLock(id: number): Observable<PrestationLock | null> {
    return this.http
      .get<PrestationLock | null>(`${this.url}/${this.endpoint}/${id}/lock`)
      .pipe(catchError(() => of(UNVERIFIED_LOCK)));
  }
}
